import {useSelector} from 'react-redux'
import {useLocation} from 'react-router'
import {selectPolicies} from 'features/Policies/policiesSelectors'
import {usePoliciesList} from 'features/Policies/usePolicyQuery'
import {Policy} from 'interfaces'

export function usePolicy() {
  const {selectedPolicyName, cloudApp} = useSelector(selectPolicies)
  const location = useLocation<{policyName: string}>()
  const {pathname, state} = location

  const policies = usePoliciesList()

  //check is categories greater than 1
  const isSinglePolicy = policies?.length === 1
  //check policy is BasePolicy
  const isBasePolicy = selectedPolicyName?.trim() === Policy.BasePolicy
  //check base policy to be colored to blue, if policies > 1
  const isBasePolicyToBeColored = policies?.length > 1 && isBasePolicy

  const isCloudAppInherited = cloudApp.data.inheritsCAC

  return {
    isBasePolicyToBeColored,
    pathname,
    isSinglePolicy,
    isBasePolicy,
    state,
    isCloudAppInherited,
    selectedPolicyName,
  }
}
